module.exports = __webpack_public_path__ + "static/media/3DPPA27.9192d6ae.jpg";